import i18next from "i18next";

export const FORM = {
    FIELD_IS_REQUIRED: i18next.t("Pole jest wymagane"),
    EMAIL_IS_INCORRECT: i18next.t("Niepoprawny adres email"),
    VALUE_IS_EXISTS: i18next.t("Wartość już istnieje"),
    VALUE_IS_OUT_OF_LIST: i18next.t("Wartość jest spoza listy"),
    VALUE_WRONG: i18next.t("Nieprawidłowa wartość"),
    PASSWORD_TOO_SHORT: i18next.t("Hasło musi mieć minimum 6 znaków"),
    PASSWORD_MUST_BE_SAME: i18next.t("Hasło musi być takie samo"),
    VALUE_MUST_BE_NUMBER: i18next.t("Wartość musi być liczbą")
};

export const OPERATIONS = {
    ADD: "ADD",
    READ: "READ",
    EDIT: "EDIT",
    DELETE: "DELETE",
    DUPLICATE: "DUPLICATE",
    MESSAGE: "MESSAGE",
    SETTLEMENT: "SETTLEMENT"
};

export const ROLES = {
    SUPERADMIN: 'superadmin',
    ADMINISTRATOR: 'administrator',
    MANAGER: 'manager'
};

export const SOCKET = {
    NOTIFICATIONS: 'notifications'
};

export const NOTIFICATIONS_TYPE = {
    CHAT_MESSAGE: 'chat_message',
    NEW_APPLICATION: "new_application",
    CANCEL_APPLICATION_BY_CANDIDATE: "cancel_application_by_candidate",
    NEW_CANDIDATE: "new_candidate"
};